export const parentTypes = [
    'root',
    'paragraph',
    'heading',
    'blockquote',
    'list',
    'listItem',
    'table',
    'tableRow',
    'tableCell',
    'footnoteDefinition',
    'emphasis',
    'strong',
    'delete',
    'link',
    'linkReference',
    'footnote',
];
export const leafBlockTypes = [
    'paragraph',
    'heading',
    'tableCell',
    'thematicBreak',
    'code',
    'html',
    'empty',
    'placeholder',
];
const isParent = (content) => {
    return parentTypes.includes(content.type);
};
export const isEmptyLikeContent = (content) => content.type === 'empty' || content.type === 'placeholder';
export const isNonEmptyContent = (content) => !isEmptyLikeContent(content);
const createEmpty = (path, ancestors, parent, line) => {
    return {
        path,
        ancestors,
        parent,
        self: {
            type: ancestors.length <= 1 ? 'empty' : 'placeholder',
            position: {
                start: {
                    line,
                    column: 1,
                },
                end: {
                    line,
                    column: 1,
                },
            },
        },
    };
};
const visitChildren = (mutableFlattenedLeafBlockList, node, parentContent, parentPath, parentAncestors) => {
    var _a, _b, _c;
    if (node.type === 'paragraph' ||
        node.type === 'heading' ||
        node.type === 'tableCell' ||
        node.type === 'thematicBreak' ||
        node.type === 'html' ||
        node.type === 'code') {
        const flattenedLeafBlock = {
            path: parentPath,
            ancestors: parentAncestors,
            self: node,
            parent: parentContent,
        };
        mutableFlattenedLeafBlockList.push(flattenedLeafBlock);
    }
    else if (isParent(node)) {
        const ancestors = parentAncestors.concat(node.type);
        if (node.children.length === 0) {
            // If there is no children, set 'placeholder' as a pseudo child leaf block.
            const startLine = (_a = node.position) === null || _a === void 0 ? void 0 : _a.start.line;
            const endLine = (_b = node.position) === null || _b === void 0 ? void 0 : _b.end.line;
            if (startLine == null || endLine == null) {
                throw new Error('Failed to obtain the start line or the end line of the node');
            }
            let pathIdx = 0;
            for (let line = startLine; line <= endLine; ++line) {
                const path = parentPath.concat(pathIdx);
                pathIdx++;
                mutableFlattenedLeafBlockList.push(createEmpty(path, ancestors, node, line));
            }
            return;
        }
        let flattenedIdx = 0;
        node.children.forEach((child, i) => {
            var _a, _b;
            let prevEndLine;
            // Fill empty lines between this child and the prev child
            if (i === 0) {
                if (node.position == null) {
                    throw new Error('Failed to obtain the start line of the node');
                }
                prevEndLine = node.position.start.line - 1;
            }
            else {
                const prevChild = node.children[i - 1];
                prevEndLine = (_a = prevChild.position) === null || _a === void 0 ? void 0 : _a.end.line;
            }
            const thisStartLine = (_b = child.position) === null || _b === void 0 ? void 0 : _b.start.line;
            if (thisStartLine == null || prevEndLine == null) {
                throw new Error('Failed to obtain the start line or the end line');
            }
            for (let line = prevEndLine + 1; line < thisStartLine; ++line) {
                const path = parentPath.concat(flattenedIdx);
                flattenedIdx++;
                mutableFlattenedLeafBlockList.push(createEmpty(path, ancestors, node, line));
            }
            const path = parentPath.concat(flattenedIdx);
            flattenedIdx++;
            visitChildren(mutableFlattenedLeafBlockList, child, node, path, ancestors);
        });
        // Following empty lines
        const lastChild = node.children[node.children.length - 1];
        const lastChildEndLine = (_c = lastChild.position) === null || _c === void 0 ? void 0 : _c.end.line;
        const parentEndLine = node.position && node.position.end.line;
        if (lastChildEndLine && parentEndLine) {
            for (let line = lastChildEndLine + 1; line <= parentEndLine; ++line) {
                const path = parentPath.concat(flattenedIdx);
                flattenedIdx++;
                mutableFlattenedLeafBlockList.push(createEmpty(path, ancestors, node, line));
            }
        }
    }
};
export const flattenMdast = (content) => {
    const mutableFlattenedLeafBlocks = [];
    visitChildren(mutableFlattenedLeafBlocks, content, undefined, [], []);
    return mutableFlattenedLeafBlocks;
};
//# sourceMappingURL=index.js.map